export default __webpack_public_path__ + "static/media/value-repurpose.b7ad3c50.svg";